module.exports = __webpack_public_path__ + "img/logo.db0bf099.svg";